<div class="container">
  <div class="title-wrap">
    <h1 class="title">{{ 'pages.widget.title' | translate }}</h1>

    <div class="actions">
      <button class="btn btn__primary" *ngIf="isEdited && editable" [disabled]="!form.dirty || !form.valid" (click)="onSubmit()">
        {{ 'pages.widget.actions.save' | translate }}
      </button>
      <button class="btn btn__secondary" *ngIf="isEdited" (click)="onCancel()">
        {{ 'pages.widget.actions.cancel' | translate }}
      </button>
      <button class="btn btn__secondary" *ngIf="!isEdited" (click)="isEdited = true">
        {{ 'pages.widget.actions.manage' | translate }}
      </button>
    </div>
  </div>
  <div class="content">
    <div class="col" [class.editable]="isEdited">
      <div class="dual-screen" [class.show-second]="showSecondScreen">
        <app-device class="first-screen" [url]="this.widgetUrl" [tableInfo]="{ widgetUIConfig: previewConfig | async }"></app-device>
        <app-device class="second-screen" [url]="this.widgetUrl"></app-device>
      </div>
      <div class="dual-screen-controls">
        <button class="btn btn__link" (click)="showSecondScreen = !showSecondScreen">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="16" viewBox="0 0 122.88 65.56" fill="currentColor">
            <path d="M23.18 27.12c-45.02 14.55 26.45 23.6 41.33 23.47v-7.44l11.21 11.2-11.21 11.21v-6.97C35.25 59.71-36.83 39.27 23.18 24.3v2.82zm84.96-18.8c0-2.74.49-4.66 1.48-5.75.99-1.09 2.49-1.64 4.51-1.64.97 0 1.77.12 2.39.36.62.24 1.13.55 1.52.93.4.38.7.79.93 1.21.23.42.41.92.55 1.48.27 1.07.4 2.2.4 3.37 0 2.62-.44 4.53-1.33 5.74-.88 1.21-2.41 1.82-4.57 1.82-1.21 0-2.19-.2-2.94-.58-.75-.39-1.36-.96-1.84-1.7-.34-.53-.62-1.26-.81-2.18-.19-.93-.29-1.95-.29-3.06zm3.97 0c0 1.83.16 3.09.49 3.76.33.67.8 1.01 1.41 1.01.41 0 .76-.14 1.06-.43.3-.29.52-.74.66-1.35.14-.62.21-1.58.21-2.88 0-1.91-.16-3.2-.49-3.86-.32-.66-.81-.99-1.46-.99-.66 0-1.14.34-1.44 1.01-.29.67-.44 1.92-.44 3.73zM37.55 0v34.85h-9.62v-22.8c-1.56 1.18-4.5 2.13-5.96 2.86s-3.29 1.43-5.48 2.09l1.44-7.76c3.24-1.05 5.76-2.31 7.55-3.78 1.8-1.48 3.2-3.3 4.21-5.46h7.86zm14.62 16.42c-1.49-.79-2.58-1.68-3.26-2.66-.93-1.34-1.4-2.88-1.4-4.62 0-2.86 1.35-5.21 4.05-7.04C53.66.7 56.44 0 59.91 0c4.59 0 7.97.87 10.16 2.62 2.19 1.74 3.29 3.94 3.29 6.58 0 1.55-.44 2.98-1.32 4.32-.66 1-1.69 1.96-3.1 2.9 1.85.89 3.24 2.07 4.15 3.53.92 1.47 1.37 3.09 1.37 4.87 0 1.72-.39 3.31-1.18 4.8-.79 1.49-1.76 2.64-2.9 3.45-1.15.81-2.58 1.4-4.28 1.79-1.71.38-3.53.57-5.47.57-3.63 0-6.4-.43-8.32-1.28-1.91-.86-3.37-2.12-4.36-3.79-1-1.67-1.5-3.53-1.5-5.59 0-2.01.47-3.71 1.4-5.11.94-1.4 2.38-2.47 4.32-3.24zm4.29-6.73c0 1.18.38 2.14 1.12 2.86.74.73 1.73 1.08 2.98 1.08 1.09 0 1.99-.36 2.7-1.08.71-.72 1.06-1.64 1.06-2.78 0-1.19-.37-2.15-1.1-2.89-.74-.74-1.68-1.11-2.82-1.11-1.16 0-2.11.36-2.83 1.08-.74.75-1.11 1.7-1.11 2.84zm-.53 14.75c0 1.52.46 2.74 1.38 3.71.92.96 1.97 1.44 3.15 1.44 1.14 0 2.16-.49 3.06-1.46.9-.97 1.36-2.21 1.36-3.71 0-1.52-.45-2.75-1.36-3.72-.92-.97-1.97-1.45-3.17-1.45-1.19 0-2.22.47-3.1 1.4-.88.93-1.32 2.2-1.32 3.79zm21.01-6.87c0-6.51 1.17-11.07 3.52-13.67C82.81 1.3 86.38 0 91.18 0c2.31 0 4.2.29 5.68.85 1.48.57 2.69 1.31 3.62 2.22.94.91 1.67 1.87 2.21 2.87.54 1.01.97 2.18 1.3 3.52.63 2.55.96 5.22.96 7.99 0 6.22-1.06 10.76-3.16 13.64-2.1 2.88-5.72 4.32-10.87 4.32-2.88 0-5.21-.46-6.99-1.38-1.78-.92-3.23-2.27-4.37-4.05-.82-1.26-1.47-2.98-1.93-5.17-.46-2.17-.69-4.59-.69-7.24zm9.43.01c0 4.36.38 7.34 1.16 8.94.77 1.6 1.89 2.39 3.36 2.39.97 0 1.8-.34 2.51-1.01.71-.68 1.23-1.76 1.56-3.22.34-1.47.5-3.75.5-6.85 0-4.55-.38-7.6-1.16-9.18-.77-1.56-1.93-2.35-3.47-2.35-1.58 0-2.71.8-3.41 2.39-.7 1.62-1.05 4.58-1.05 8.89zm21.52 11.75c12.16 5.39 10.25 13.47-9.24 18.29-5.3 1.31-11.29 2.5-17.86 2.99v6.05c7.31-.51 14.1-2.19 20.06-3.63 28.88-7 27.06-19.64 7.88-26.37-.24.95-.52 1.84-.84 2.67z" />
          </svg>

          <ng-container *ngIf="showSecondScreen; else showFirstScreenText">
            {{ 'pages.widget.actions.showFirstScreen' | translate }}
          </ng-container>
          <ng-template #showFirstScreenText>
            {{ 'pages.widget.actions.showSecondScreen' | translate }}
          </ng-template>
        </button>
      </div>
    </div>
    <div class="col editing" *ngIf="isEdited">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <fieldset>
          <legend>{{ 'pages.widget.form.main' | translate }}</legend>
          <mat-form-field class="field">
            <mat-label>{{ 'pages.widget.form.idleDelay' | translate }}</mat-label>
            <mat-select formControlName="idleDelay" >
              <mat-option [value]=0>{{ 'pages.widget.form.delay.disabled' | translate }}</mat-option>
              <mat-option [value]=10>10{{ 'pages.widget.form.delay.seconds' | translate }}</mat-option>
              <mat-option [value]=15>15{{ 'pages.widget.form.delay.seconds' | translate }}</mat-option>
              <mat-option [value]=20>20{{ 'pages.widget.form.delay.seconds' | translate }}</mat-option>
              <mat-option [value]=25>25{{ 'pages.widget.form.delay.seconds' | translate }}</mat-option>
              <mat-option [value]=30>30{{ 'pages.widget.form.delay.seconds' | translate }}</mat-option>
              <mat-option [value]=35>35{{ 'pages.widget.form.delay.seconds' | translate }}</mat-option>
              <mat-option [value]=40>40{{ 'pages.widget.form.delay.seconds' | translate }}</mat-option>
              <mat-option [value]=45>45{{ 'pages.widget.form.delay.seconds' | translate }}</mat-option>
              <mat-option [value]=50>50{{ 'pages.widget.form.delay.seconds' | translate }}</mat-option>
              <mat-option [value]=55>55{{ 'pages.widget.form.delay.seconds' | translate }}</mat-option>
              <mat-option [value]=60>60{{ 'pages.widget.form.delay.seconds' | translate }}</mat-option>
              <mat-option [value]=70>70{{ 'pages.widget.form.delay.seconds' | translate }}</mat-option>
              <mat-option [value]=80>80{{ 'pages.widget.form.delay.seconds' | translate }}</mat-option>
              <mat-option [value]=90>90{{ 'pages.widget.form.delay.seconds' | translate }}</mat-option>
            </mat-select>
            <mat-hint>{{ 'pages.widget.form.delay.hint' | translate }}</mat-hint>
          </mat-form-field>
          <div class="field" *ngIf="this.form.get('idleDelay')?.value !== 0">
            <mat-checkbox formControlName="tabBarAutoHide" color="primary">{{ 'pages.widget.form.tabBarAutoHide' | translate }}</mat-checkbox>
          </div>
          <div><mat-label>{{ 'pages.widget.form.logo.title' | translate }}</mat-label>
            <app-form-file-upload
              appDragAndDropFiles
              formControlName="logo"
              accept="image/*"
            >{{ 'formFilUpload.dragAndDrop' | translate }}</app-form-file-upload>
          </div>
        </fieldset>

        <fieldset formGroupName="colors">
          <legend>{{ 'pages.widget.form.colors.title' | translate }}</legend>

          <div class="palette">
            <button type="button" *ngFor="let palette of palettes" [class.active]="isCurrentPalette(palette)" (click)="applyPalette(palette)">
              <div class="name">{{ palette.name }}</div>
              <div class="colors">
                <div class="color" [style.background-color]="palette.colors.primary"></div>
                <div class="color" [style.background-color]="palette.colors.secondary"></div>
                <div class="color" [style.background-color]="palette.colors.tertiary"></div>
              </div>
            </button>
          </div>
          <div class="fields">
            <mat-form-field appearance="standard">
              <mat-label>{{ 'pages.widget.form.colors.primary.label' | translate }}</mat-label>
              <input matInput formControlName="primary" type="color">
            </mat-form-field>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'pages.widget.form.colors.secondary.label' | translate }}</mat-label>
              <input matInput formControlName="secondary" type="color">
            </mat-form-field>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'pages.widget.form.colors.tertiary.label' | translate }}</mat-label>
              <input matInput formControlName="tertiary" type="color">
            </mat-form-field>
          </div>
        </fieldset>

        <fieldset formGroupName="pages">
          <legend>{{ 'pages.widget.form.pages.legend' | translate }}</legend>
          <mat-tab-group>
            <mat-tab label="{{ 'pages.widget.form.pages.menu.label' | translate }}" formGroupName="menu">
              <div class="field">
                <mat-checkbox formControlName="enabled" color="primary">{{ 'pages.widget.form.pages.menu.enable' | translate }}</mat-checkbox>
              </div>
              <div class="field" [class.blur]="!this.form.get('pages.menu.enabled')?.value">
                <mat-form-field appearance="standard">
                  <mat-label>{{ 'pages.widget.form.pages.menu.name' | translate }}</mat-label>
                  <input matInput formControlName="name">
                  <mat-error *ngIf="form.get('pages.menu.name')?.errors?.required">
                    {{ 'pages.widget.form.errors.required' | translate }}
                  </mat-error>
                  <mat-error *ngIf="form.get('pages.menu.name')?.errors?.maxlength">
                    {{ 'pages.widget.form.errors.maxlength' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="field" [class.blur]="!this.form.get('pages.menu.enabled')?.value">
                <label>{{ 'pages.widget.form.pages.menu.icon' | translate }}</label>
                <app-form-file-upload
                  appDragAndDropFiles
                  formControlName="icon"
                  accept="image/*"
                >{{ 'formFilUpload.dragAndDrop' | translate }}</app-form-file-upload>
              </div>
            </mat-tab>
            <mat-tab label="{{ 'pages.widget.form.pages.serviceCenter.label' | translate }}" formGroupName="serviceCenter">
              <div class="field">
                <mat-checkbox formControlName="enabled" color="primary">{{ 'pages.widget.form.pages.serviceCenter.enable' | translate }}</mat-checkbox>
              </div>
              <div class="field" [class.blur]="!this.form.get('pages.serviceCenter.enabled')?.value">
                <mat-form-field appearance="standard">
                  <mat-label>{{ 'pages.widget.form.pages.serviceCenter.name' | translate }}</mat-label>
                  <input matInput formControlName="name">
                  <mat-error *ngIf="form.get('pages.serviceCenter.name')?.errors?.required">
                    {{ 'pages.widget.form.errors.required' | translate }}
                  </mat-error>
                  <mat-error *ngIf="form.get('pages.serviceCenter.name')?.errors?.maxlength">
                    {{ 'pages.widget.form.errors.maxlength' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="field" [class.blur]="!this.form.get('pages.serviceCenter.enabled')?.value">
                <app-form-file-upload
                  appDragAndDropFiles
                  formControlName="icon"
                  accept="image/*"
                >{{ 'formFilUpload.dragAndDrop' | translate }}</app-form-file-upload>
              </div>
            </mat-tab>
            <mat-tab label="{{ 'pages.widget.form.pages.invoice.label' | translate }}" formGroupName="invoice">
              <div class="field">
                <mat-checkbox formControlName="enabled" color="primary">{{ 'pages.widget.form.pages.invoice.enable' | translate }}</mat-checkbox>
              </div>
              <div class="field" [class.blur]="!this.form.get('pages.invoice.enabled')?.value">
                <mat-form-field appearance="standard">
                  <mat-label>{{ 'pages.widget.form.pages.invoice.name' | translate }}</mat-label>
                  <input matInput formControlName="name">
                  <mat-error *ngIf="form.get('pages.invoice.name')?.errors?.required">
                    {{ 'pages.widget.form.errors.required' | translate }}
                  </mat-error>
                  <mat-error *ngIf="form.get('pages.invoice.name')?.errors?.maxlength">
                    {{ 'pages.widget.form.errors.maxlength' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="field" [class.blur]="!this.form.get('pages.invoice.enabled')?.value">
                <label>{{ 'pages.widget.form.pages.invoice.icon' | translate }}</label>
                <app-form-file-upload
                  appDragAndDropFiles
                  formControlName="icon"
                  accept="image/*"
                >{{ 'formFilUpload.dragAndDrop' | translate }}</app-form-file-upload>
              </div>
            </mat-tab>
          </mat-tab-group>
        </fieldset>

        <fieldset formGroupName="callWaiterButtons">
          <legend>{{ 'pages.widget.form.callWaiterButtons.legend' | translate }}</legend>
          <mat-tab-group>
            <mat-tab label="{{ 'pages.widget.form.callWaiterButtons.callWaiter.legend' | translate }}" formGroupName="callWaiter">
              <div class="field">
                <mat-checkbox formControlName="enabled" color="primary">
                  {{ 'pages.widget.form.callWaiterButtons.callWaiter.enable' | translate }}
                </mat-checkbox>
              </div>
              <div class="field" [class.blur]="!this.form.get('callWaiterButtons.callWaiter.enabled')?.value">
                <mat-form-field appearance="standard">
                  <mat-label>{{ 'pages.widget.form.callWaiterButtons.callWaiter.name' | translate }}</mat-label>
                  <input matInput formControlName="name">
                  <mat-error *ngIf="form.get('callWaiterButtons.callWaiter.name')?.errors?.required">
                    {{ 'pages.widget.form.errors.required' | translate }}
                  </mat-error>
                  <mat-error *ngIf="form.get('callWaiterButtons.callWaiter.name')?.errors?.maxlength">
                    {{ 'pages.widget.form.errors.maxlength' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="field" [class.blur]="!this.form.get('callWaiterButtons.callWaiter.enabled')?.value">
                <mat-form-field>
                  <mat-label>{{ 'pages.widget.form.callWaiterButtons.colorOfLights.label' | translate }}</mat-label>
                  <mat-select formControlName="lightsColor">
                    <mat-option [value]="null">{{ 'pages.widget.form.callWaiterButtons.colorOfLights.noLights' | translate }}</mat-option>
                    <mat-option value="#ff0000">{{ 'pages.widget.form.callWaiterButtons.colorOfLights.red' | translate }}</mat-option>
                    <mat-option value="#00ff00">{{ 'pages.widget.form.callWaiterButtons.colorOfLights.green' | translate }}</mat-option>
                    <mat-option value="#ffff00">{{ 'pages.widget.form.callWaiterButtons.colorOfLights.yellow' | translate }}</mat-option>
                    <mat-option value="#0000ff">{{ 'pages.widget.form.callWaiterButtons.colorOfLights.blue' | translate }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </mat-tab>
            <mat-tab
              label="{{ 'pages.widget.form.callWaiterButtons.anotherRound.legend' | translate }}"
              formGroupName="anotherRound"
              *ngIf="!!this.form.get('pages.serviceCenter.enabled')?.value"
            >
              <div class="field">
                <mat-checkbox formControlName="enabled" color="primary">
                  {{ 'pages.widget.form.callWaiterButtons.anotherRound.enable' | translate }}
                </mat-checkbox>
              </div>
              <div class="field" [class.blur]="!this.form.get('callWaiterButtons.anotherRound.enabled')?.value">
                <mat-form-field appearance="standard">
                  <mat-label>{{ 'pages.widget.form.callWaiterButtons.anotherRound.name' | translate }}</mat-label>
                  <input matInput formControlName="name">
                  <mat-error *ngIf="form.get('callWaiterButtons.anotherRound.name')?.errors?.required">
                    {{ 'pages.widget.form.errors.required' | translate }}
                  </mat-error>
                  <mat-error *ngIf="form.get('callWaiterButtons.anotherRound.name')?.errors?.maxlength">
                    {{ 'pages.widget.form.errors.maxlength' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="field" [class.blur]="!this.form.get('callWaiterButtons.anotherRound.enabled')?.value">
                <mat-form-field>
                  <mat-label>{{ 'pages.widget.form.callWaiterButtons.colorOfLights.label' | translate }}</mat-label>
                  <mat-select formControlName="lightsColor">
                    <mat-option [value]="null">{{ 'pages.widget.form.callWaiterButtons.colorOfLights.noLights' | translate }}</mat-option>
                    <mat-option value="#ff0000">{{ 'pages.widget.form.callWaiterButtons.colorOfLights.red' | translate }}</mat-option>
                    <mat-option value="#00ff00">{{ 'pages.widget.form.callWaiterButtons.colorOfLights.green' | translate }}</mat-option>
                    <mat-option value="#ffff00">{{ 'pages.widget.form.callWaiterButtons.colorOfLights.yellow' | translate }}</mat-option>
                    <mat-option value="#0000ff">{{ 'pages.widget.form.callWaiterButtons.colorOfLights.blue' | translate }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </mat-tab>
            <mat-tab
              label="{{ 'pages.widget.form.callWaiterButtons.requestBill.legend' | translate }}"
              formGroupName="requestBill"
              *ngIf="!!this.form.get('pages.invoice.enabled')?.value
            ">
              <div class="field">
                <mat-checkbox formControlName="enabled" color="primary">
                  {{ 'pages.widget.form.callWaiterButtons.requestBill.enable' | translate }}
                </mat-checkbox>
              </div>
              <div class="field" [class.blur]="!this.form.get('callWaiterButtons.requestBill.enabled')?.value">
                <mat-form-field appearance="standard">
                  <mat-label>{{ 'pages.widget.form.callWaiterButtons.requestBill.name' | translate }}</mat-label>
                  <input matInput formControlName="name">
                  <mat-error *ngIf="form.get('callWaiterButtons.requestBill.name')?.errors?.required">
                    {{ 'pages.widget.form.errors.required' | translate }}
                  </mat-error>
                  <mat-error *ngIf="form.get('callWaiterButtons.requestBill.name')?.errors?.maxlength">
                    {{ 'pages.widget.form.errors.maxlength' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="field" [class.blur]="!this.form.get('callWaiterButtons.requestBill.enabled')?.value">
                <mat-form-field>
                  <mat-label>{{ 'pages.widget.form.callWaiterButtons.colorOfLights.label' | translate }}</mat-label>
                  <mat-select formControlName="lightsColor">
                    <mat-option [value]="null">{{ 'pages.widget.form.callWaiterButtons.colorOfLights.noLights' | translate }}</mat-option>
                    <mat-option value="#ff0000">{{ 'pages.widget.form.callWaiterButtons.colorOfLights.red' | translate }}</mat-option>
                    <mat-option value="#00ff00">{{ 'pages.widget.form.callWaiterButtons.colorOfLights.green' | translate }}</mat-option>
                    <mat-option value="#ffff00">{{ 'pages.widget.form.callWaiterButtons.colorOfLights.yellow' | translate }}</mat-option>
                    <mat-option value="#0000ff">{{ 'pages.widget.form.callWaiterButtons.colorOfLights.blue' | translate }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </mat-tab>
          </mat-tab-group>
        </fieldset>
      </form>

      <div class="reset-wrapper" *ngIf="editable">
        <button (click)="onResetToFactory()">
          Reset to default configuration
        </button>
      </div>
    </div>
  </div>
</div>
